import * as yup from 'yup';
import { MAX_DEFAULT_FIELD_SYMBOLS } from 'constants/general';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getTagFormSchema = (localize: TLocalize) =>
  yup.object().shape({
    name: yup
      .string()
      .required(localize('validation.admin.tag.name.required') as string)
      .max(
        MAX_DEFAULT_FIELD_SYMBOLS,
        localize('validation.admin.tag.name.max', [
          String(MAX_DEFAULT_FIELD_SYMBOLS),
        ]) as string
      ),
    color: yup
      .string()
      .required(localize('validation.admin.tag.color.required') as string)
      .matches(
        /^#[0-9A-Fa-f]{6}$/,
        localize('validation.admin.tag.color.hex') as string
      ),
  });
